import React, { Component } from 'react'
import { connect } from 'react-redux'
import Tabs from '../../../chassis/tabs'
import { UserBannerProfilePanel } from './userBannerProfilePanel'
import { UserBannerSupportPanel } from './userBannerSupportPanel'
import { UserBannerOtherPanel } from './userBannerOtherPanel'
import UserBannerZendeskPanel from './userBannerZendeskPanel'
import { fetchUserTickets } from '../userActions'
import { User, Address } from '../../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  user: User
  address: Address | undefined
  fetchUserTickets?: Callback
}

interface State {
  ticketsRequested: boolean
}

const ZENDESK_TAB_INDEX = 2

export class UserBannerTabs extends Component<Props, State> {
  static displayName = 'UserBannerTabs'

  state: State = { ticketsRequested: false }

  // The chassis Tabs component mounts every panel and hides the inactive ones
  // with CSS, so the Zendesk panel cannot fetch on mount without paying the
  // Zendesk round trip on every profile view. Load on first open of the tab.
  loadTickets = () => {
    const { user, fetchUserTickets } = this.props
    if (this.state.ticketsRequested || !user || !user.id || !fetchUserTickets) {
      return
    }

    this.setState({ ticketsRequested: true })
    fetchUserTickets(user.id)
  }

  render() {
    const { user, address } = this.props
    const defaultActiveTabIndex = 0

    return (
      <Tabs
        defaultActiveTabIndex={defaultActiveTabIndex}
        data-test="user-banner-tabs"
        className="user-banner__tabs"
        render={({ List, Tab, Panel }) => (
          <div>
            <List>
              <Tab index={0}>Profile</Tab>
              <Tab index={1}>Support</Tab>
              <Tab index={ZENDESK_TAB_INDEX} onClick={this.loadTickets}>
                Zendesk
              </Tab>
              <Tab index={3}>Other</Tab>
            </List>
            <Panel index={0}>
              <UserBannerProfilePanel user={user} address={address} />
            </Panel>
            <Panel index={1}>
              <UserBannerSupportPanel />
            </Panel>
            <Panel index={ZENDESK_TAB_INDEX}>
              <UserBannerZendeskPanel
                user={user}
                isLoading={this.state.ticketsRequested && !user.tickets}
              />
            </Panel>
            <Panel index={3}>
              <UserBannerOtherPanel user={user} />
            </Panel>
          </div>
        )}
      />
    )
  }
}

export default connect(null, { fetchUserTickets })(UserBannerTabs)
